import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, reset, initialize, change } from 'redux-form';
import UpdateDueDatesDialog from './UpdateDueDatesDialog';
import { IApplicationState } from 'ducks/reducers';
import { selectors as purchaseOrdersSelectors } from 'ducks/purchaseOrders/purchaseOrders';

const FORM_NAME = 'UpdateDueDatesForm';
const mapStateToProps = (state: IApplicationState) => ({
    selectedPurchaseOrder: purchaseOrdersSelectors.selectedPurchaseOrder(state) ?? (new URLSearchParams(location.search).get('PurchaseOrder') ?? ''),
    dirty: isDirty(FORM_NAME)(state),
    values: getFormValues(FORM_NAME)(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        initializeForm: (values) => initialize(FORM_NAME, values),
        changeFormFieldValue: (fieldName: string, fieldValue: any) => change(FORM_NAME, fieldName, fieldValue),
        resetForm: () => reset(FORM_NAME),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDueDatesDialog);
